export default {
    fields: {
        name: "Name",
        duration: "Dauer",
        firstName: "Vorname",
        lastName: "Nachname",
        email: "Email",
        confirmationEmail: "Kunden-Emailadresse",
        phone: "Telefon",
        minimalAdvancedHours: "Mindestvorlauf",
        lockReservationsForTodayAt: "Termine für heute sperren ab",
        lockReservationsForTomorrowAt: "Termine für morgen sperren ab",
        minimalAdvancedDays: "Minimum Tage im Voraus",
        slotStep: "slot step-15",
    },
    c: {
        minutes: "Minuten",
        hours: "Stunden",
        hours00: ":00",
        oclock: "Uhr",
        days: "Tage",
        municipality: "Gemeinde",
    },
    error: "Etwas ist schiefgelaufen :(",
    login: {
        submit: "Login",
        username: "Benutzername",
        password: "Passwort",
        register: "Registrieren",
        errors: {
            credentials: "Benutzername oder Passwort falsch",
        },
    },
    register: {
        success: "Erfolgreich registiert",
        errors: {
            rejected: "Fehler bei der Registrierung",
        },
    },
    registerForm: {
        email: "Email",
        password: "Passwort",
        confirmPassword: "Passwort wiederholen",
        back: "Zurück",
        submit: "Registrieren",
    },
    lastMinute: {
        address: "Adresse",
        contact: "Ihre E-Mail",
        book: "Einen Termin verabreden",
        error: "Keine Termine",
        booked: "Vielen Dank! Termin gebucht",
        customeurl: "Benutzerdefinierte Weiterleitungs-URL"
    },
    business: {
        dashboard: {
            title: "Übersicht",
            today: "Termine am",
            todaytable: {
                date: "Datum",
                time: "Zeit",
                duration: "Dauer",
                customer: "Kunde",
                offers: "Dienstleistungen",
            },
            employeestoday: {
                header: "",
            },
            customerstoday: {
                header: "",
            },
            calendarSync: {
                title: "Kalendersynchronisierung",
                settings: "Integrationseinstellungen öffnen",
                unavailable: "Der Synchronisierungsstatus ist vorübergehend nicht verfügbar",
                pending: "Der Synchronisierungsstatus wird geprüft",
                retry: "Bitte später erneut versuchen",
                affectedProfiles: "Betroffene Profile ({count})",
                status: {
                    NOT_CONNECTED: "Kein Kalender verbunden",
                    UNKNOWN: "Synchronisierung wird geprüft",
                    OK: "Synchronisierung aktiv",
                    JOB_NOT_RUNNING: "Synchronisierung pausiert",
                    TOKEN_INVALID: "Autorisierung ungültig",
                    SELECTION_STALE: "Kalenderauswahl nicht mehr vorhanden",
                    NO_WRITABLE_CALENDAR: "Kein beschreibbarer Kalender",
                    EMPTY_ACCOUNT: "Konto ohne Kalender",
                },
            },
            table: {
                nodata: "Heute keine Termine",
            },
        },
        tabs: {
            dashboard: "Übersicht",
            schedule: "Agenda",
            holidays: "Feiertage/Ferien",
            open: "Wochenplan",
            exceptions: "Ausnahmen",
            offers: "Angebot",
            settings: "Einstellungen",
            customers: "Kunden",
        },
        sidebar: {
            dashboard: "Startseite",
            business: "Administration",
            customers: "Kunden",
            appointments: "Alle Termine",
            logs: "Historie",
            newappointment: "Neuer Termin",
            offers: "Angebot",
            time: "Öffnungszeiten",
            integration: "Externer Kalender",
            events: "Protokoll",
        },
        holidays: {
            form: {
                name: "Name des Feiertags",
                header: {
                    new: "Neuer Feiertag",
                    edit: "Feiertag bearbeiten",
                },
                from: {
                    label: "Datum",
                    placeholder: "Datum des Feiertages",
                },
                to: {
                    label: "bis am",
                    placeholder: "Ende der Feiertage",
                },
                period: "Zeitraum",
                update: "aktualisieren",
                delete: "löschen",
                create: "speichern",
                cancel: "abbrechen",
            },
            table: {
                addholiday: {
                    button: "Feiertag hinzufügen",
                },
                name: "Name",
                from: "von",
                to: "bis",
                nodata: "keine Feiertage",
            },
            import: {
                delete: {
                    message: "Möchten Sie wirklich alle importierten Feiertage löschen?",
                },
            },
        },
        exceptions: {
            add: "Ausnahme hinzufügen",
            addhours: "Zeitraum hinzufügen",
            save: "Speichern",
            cancel: "abbrechen",
            delete: "Löschen",
            edit: "Bearbeiten",
        },
        offers: {
            add: {
                offer: "Angebot hinzufügen",
                duration: "Dauer hinzufügen",
            },
            drop: {
                duration: "Dauer entfernen",
            },
            offer: {
                offer: "Angebot",
                name: "Name des Angebotes",
                internal: "Interner Name des Angebotes",
                pre: "Vorlaufzeit",
                duration: "Dauer",
                post: "Nachlaufzeit",
                active: "aktiv",
            },
            create: "Angebot hinzufügen",
            update: "Angebot speichern",
            cancel: "Abbrechen",
            delete: "Angebot löschen",
        },
        settings: {
            tab: {
                business: "Geschäft",
                lastMinute: "Letzte Minute",
                rules: "Grundregeln",
                integrations: "Integrationen",
                display: "Anzeige",
            },
            notifications: {
                tab: "Benachrichtigungen",
                event: "Ereignis",
                customer: "Kunde",
                employee: "Mitarbeiter",
                business: "Geschäft",
                save: "Speichern",
                saved: "Benachrichtigungen gespeichert",
                events: {
                    CUSTOMER_REQUEST: "Kunde: Anfrage",
                    CUSTOMER_CONFIRMATION: "Kunde: Bestätigung",
                    CUSTOMER_CANCELLATION: "Kunde: Storno",
                    CUSTOMER_MESSAGE: "Kunde: Nachricht",
                    USER_NEW_APPOINTMENT: "Benutzer: Neuer Termin",
                    USER_CANCELLATION: "Benutzer: Storno",
                    SYSTEM_MISSING_CONFIRMATION: "System: fehlende Bestätigung",
                },
            },
            display: {
                hours: "Angezeigte Stunden",
                from: "von",
                to: "bis",
            },
            colors: {
                external: "Externe Termine",
                unconfirmed: "Unbestätigte Termine",
                confirmed: "Bestätigte Termine",
                holidays: "Ferien und Feiertage",
                update: "Farbeinstellungen erfolgreich aktualisiert",
            },
            business: {
                name: "Firmenname",
                logo: "Firmenlogo",
                changeLogo: "Logo ändern",
                deleteLogo: "Logo löschen",
                address: "Firmenanschrift",
                email: "Email der Firma",
                mobile: "Mobile der Firma",
                notifyEmail: "per Email benachrichtigen",
                update: "Die Geschäftseinstellungen wurden erfolgreich aktualisiert",
            },
            lastMinute: {
                enable: "Last-Minute-Seite aktivieren",
                page: "Last Minute Seite",
                text: "Text",
                appointments: "Anzahl der Last-Minute-Termine",
                submit: "Seite senden",
                submitted: "Last Minute Seite aktualisiert",
            },
            notify: "benachrichtigen",
            email: {
                invalid: "Die Email Adresse ist ungültig",
            },
            update: "Speichern",
            owner: {
                name: "Leitung Name",
                email: "Leitung Email",
                mobile: "Leitung Mobile",
                notify: "benachrichtigen",
            },
            integration: {
                name: "Integrationen",
                provider: "Anbieter",
                profile: "Email-Konto",
                action: "Aktion",
                delete: "löschen",
                addcalendar: "Kalender anbinden",
                calendar: {
                    title: "Kalender für Synchronisierung",
                    current: "Aktuelle Auswahl",
                    target: "Zielkalender",
                    readonly: "(schreibgeschützt)",
                    none: "Keine Kalender vorhanden",
                    stale: "Auswahl nicht mehr vorhanden",
                    notActive: "Nur das aktive Profil synchronisiert; Auswahl deaktiviert",
                    preview: "Vorschau",
                    execute: "Kalender wechseln",
                    toMove: "randevu-bound Buchungen zu verschieben",
                    alreadyOnTarget: "randevu-bound bereits am Ziel",
                    toDrop: "remote-bound Einträge lokal zu entfernen",
                    manualReview: "Manuelle Prüfung nötig",
                    switched: "Kalender erfolgreich gewechselt",
                    confirm: "Kalender jetzt wechseln?",
                    failures: "Fehlgeschlagene Zeilen",
                    statusActive: "Synchronisierung aktiv",
                    statusPaused: "Synchronisierung pausiert",
                    statusInactive: "Nicht synchronisiert",
                    statusStale: "Auswahl nicht mehr vorhanden",
                    selectionNoLongerExists: "Auswahl nicht mehr vorhanden",
                    synchronizationPaused: "Synchronisierung pausiert",
                },
            },
            hours: {
                hoursadvance: "Buchung min. Stunden vorher",
                daysahead: "Buchung max. Tage im Voraus",
                locktomorrow: "Buchungen für Folgetag sperren ab",
                locktoday: "Buchungen für heute sperren ab",
                slotstep: "Terminbeginn alle x Minuten",
                update: "Stunden erfolgreich aktualisiert",
                error: "Von Stunde muss weniger als bis Stunde sein",
            },
            booking: {
                url: "Adresse für Onlinebuchungen",
                copy: "kopieren",
                goto: "Öffnen",
            },
        },
        newappt: {
            firstName: {
                label: "Vorname",
            },
            lastName: {
                label: "Nachname",
            },
            email: {
                label: "Email",
            },
            phone: {
                label: "Telefon",
            },
            comment: {
                label: "Kommentar",
            },
            appointment: {
                create: "Termin speichern",
                cancel: "abbrechen",
                confirm: "speichern",
                delete: "verwerfen",
            },
            confirmation: {
                title: "Bestätigung senden?",
                saved: "Termin wurde gespeichert",
                send: "Senden",
                finish: "Fertig",
                queued: "Bestätigung wird gesendet",
                failed: "Termin gespeichert, Bestätigung konnte nicht gesendet werden",
            },
            errors: {
                taken: "Dieser Termin ist bereits vergeben",
                booking: "Termin konnte nicht gespeichert werden",
            },
            offers: {
                nodata: "Keine Angebote",
            },
        },
        import: {
            cleanup: {
                header: "importierte Feiertage löschen",
            },
            header: "Feiertage importieren",
            submit: "importieren",
            delete: "importierte löschen",
        },
        open: {
            title: "Öffnungszeiten",
            edit: "Bearbeiten",
            save: "Speichern",
            delete: "Löschen",
            cancel: "Abbrechen",
        },
        time: {
            tabs: {
                overview: "Übersicht",
            },
        },
        events: {
            loadmore: "mehr laden...",
        },
        integration: {
            tabs: {
                calendar: "Kalender",
            },
        },
    },

    help: {
        business: {
            dashboard: {
                todaylist: {
                    title: "Übersicht der Termine",
                    text: "Hier finden Sie eine Übersicht der heutigen Termine",
                },
            },
        },
    },

    exceptions: {
        title: "Ausnahmen",
    },
    customer: {
        table: {
            lastName: "Nachname",
            firstName: "Vorname",
            email: "Email",
            phone: "Telefon",
            appointments: "Termine",
            nodata: "keine Kunden",
        },
    },

    header: {
        menu: {
            logout: "logout",
        },
    },

    appointments: {
        label: "Alle Termine",
        update: "Speichern",
        notification: {
            updatesuccess: "Termin wird erfolgreich aktualisiert",
            updateerror: "Termin wird nicht aktualisiert, bitte erneut versuchen",
        },
        table: {
            nodata: "Keine Termine",
            time: "Termine",
            name: "Name",
            duration: "Dauer",
            notes: "Anmerkungen",
            action: "Aktion",
            source: "Quelle",
            offers: "Dienstleistungen",
            delete: "löschen",
            edit: "Bearbeiten",
            rndBound: "Buchung",
            calBound: "Kalender",
            managedInCalendar: "Im verbundenen Kalender ändern",
            notconfirmed: "nicht bestätigt"
        },
        dialog: {
            delete: {
                title: "Termin löschen",
                message:
                    "Sind Sie sicher, dass Sie diesen Termin <b>löschen</b> wollen?",
                cancel: "Abbrechen",
                confirm: "Termin löschen",
                done: "Termin gelöscht",
            },
        },
        noCalendar: {
            button: "Kein Kalender verbunden",
            title: "Kein Kalender verbunden",
            message: "verbliebene Einträge von externem Kalender in randevu löschen?",
            confirm: "Ja",
            cancel: "Nein",
            done: "Einträge gelöscht",
        },
    },

    admin: {
        test: {
            label: "Admin Test",
        },
        sidebar: {
            test: "Admin Test",
            dashboard: "Dashboard",
            api: "APIs",
            import: "Import",
            calendarSync: "Kalendersync",
        },
        calendarSync: {
            eyebrow: "Betrieb / Kalender-Sync",
            title: "Kalendersynchronisierung",
            intro: "Verbindungen, wirksame Kalender und synchronisierte Einträge über alle Konten.",
            refresh: "Aktualisieren",
            guide: {
                button: "Info",
                title: "Welche Aktion ist richtig?",
                intro: "For “sync not working,” always start with Diagnose, then normally use Neu verbinden.",
                warning: "Do not use Trennen as a repair step.",
                buttonColumn: "Button",
                useColumn: "Use it when",
                reconnectButton: "Neu verbinden",
                reconnectUse: "Sync should continue, but authorization/account/calendar is wrong or invalid. Press only when the customer is ready—the link expires after 15 minutes. Send the link, then press Status prüfen, select a writable calendar, and Ersatz aktivieren",
                disconnectButton: "Trennen",
                disconnectUse: "The customer no longer wants calendar sync and the integration should be permanently removed. Review the preview, then confirm the destructive cleanup",
                close: "Schliessen",
            },
            accounts: "Konten",
            configured: "mit Anbieter",
            attention: "Zu prüfen",
            attentionHint: "Konfiguration oder Metadaten",
            activeUp: "Aktiv UP",
            activeDown: "Aktiv DOWN",
            allTime: "Gesamt",
            search: "Konto, E-Mail oder Kalender suchen",
            allProviders: "Alle Anbieter",
            onlyAttention: "Nur zu prüfen",
            updated: "Stand",
            id: "ID",
            account: "Konto",
            providerLabel: "Anbieter",
            calendar: "Kalender",
            readOnly: "Nur lesen",
            status: "Status",
            active: "Aktiv",
            profiles: "Profile aktiv / total",
            empty: "Keine passenden Konten gefunden",
            upDefinition: "UP: Randevu-Buchungen beim Anbieter",
            downDefinition: "DOWN: Anbieter-Einträge in Randevu",
            activeDefinition: "Aktiv: zukünftig und nicht gelöscht",
            metadataPending: "Metadaten ausstehend",
            readiness: {
                notReady: "Nicht synchronisationsbereit",
                noCalendars: "Keine Kalender gefunden",
                emptyAccountContext: "{provider}-Konto autorisiert · {count} Kalender gefunden",
                emptyAccountAction: "Kalender anlegen/freigeben oder falsches Konto neu verbinden",
            },
            loadError: "Kalender-Sync-Übersicht konnte nicht geladen werden",
            loading: "Kalender-Sync-Übersicht wird geladen",
            unavailable: "Kalender-Sync-Daten sind derzeit nicht verfügbar",
            retry: "Erneut versuchen",
            lastVerified: "Zuletzt geprüft",
            actions: "Aktionen",
            diagnose: "Diagnose",
            disconnect: "Trennen",
            reconnect: "Neu verbinden",
            disconnectPreview: "Trennvorschau",
            confirmDisconnect: "Trennung bestätigen",
            disconnectSucceeded: "Verbindung sicher getrennt",
            reasonRequired: "Bitte einen nachvollziehbaren Grund angeben",
            createAuthorization: "Autorisierungslink erstellen",
            reconnectPending: "Kundenfreigabe ausstehend",
            customerMustAuthorize: "Der Kunde muss den Anbieterzugriff über den Link freigeben",
            customerAuthorization: "Autorisierungslink öffnen",
            checkReconnect: "Status prüfen",
            selectCalendar: "Schreibbaren Kalender wählen",
            activateReplacement: "Ersatz aktivieren",
            confirmIdentityChange: "Anbieteridentität und Kalender prüfen und die Ersatzverbindung ausdrücklich aktivieren",
            replacementActivated: "Ersatz aktiviert; die alte Verbindung bleibt bis zur Gesundheitsprüfung erhalten",
            operationFailed: "Aktion fehlgeschlagen",
            health: {
                OK: "Sync in Ordnung",
                EMPTY_ACCOUNT: "Konto ohne Kalender",
                TOKEN_INVALID: "Autorisierung ungültig",
                NO_WRITABLE_CALENDAR: "Kein beschreibbarer Kalender",
                SELECTION_STALE: "Kalenderauswahl veraltet",
                PROVIDER_UNAVAILABLE: "Anbieter nicht erreichbar",
                UNKNOWN_ERROR: "Status unbekannt",
                JOB_NOT_RUNNING: "Sync-Job läuft nicht",
            },
            provider: {
                NONE: "Keiner",
                UNKNOWN: "Unbekannt",
            },
            states: {
                NONE: "Nicht verbunden",
                CONNECTED: "Verbunden",
                TOKEN_MISSING: "Token fehlt",
                DISABLED: "Deaktiviert",
                READ_ONLY: "Nur lesen",
            },
            calendarTypes: {
                NONE: "Kein Kalender",
                MAIN: "Hauptkalender",
                SUBCALENDAR: "Unterkalender",
                UNKNOWN: "Typ unbekannt",
            },
            warnings: {
                SYNC_DISABLED: "Sync deaktiviert",
                TOKEN_MISSING: "Token fehlt",
                CALENDAR_READ_ONLY: "Kalender nur lesbar",
                MULTIPLE_ACTIVE_PROFILES: "Mehrere aktive Profile",
                UNKNOWN_PROVIDER: "Anbieter unbekannt",
                CALENDAR_METADATA_PENDING: "Kalenderdaten ausstehend",
                CALENDAR_SELECTION_STALE: "Auswahl veraltet",
                HEALTH_SNAPSHOT_PENDING: "Gesundheitsdaten ausstehend",
                JOB_NOT_RUNNING: "Sync-Job läuft nicht",
                EMPTY_ACCOUNT: "Konto ohne Kalender",
                TOKEN_INVALID: "Autorisierung ungültig",
                NO_WRITABLE_CALENDAR: "Kein beschreibbarer Kalender",
                SELECTION_STALE: "Auswahl veraltet",
                PROVIDER_UNAVAILABLE: "Anbieter nicht erreichbar",
                UNKNOWN_ERROR: "Status unbekannt",
            },
        },
    },

    logs: {
        label: "Historie",
    },

    validation: {
        timeformat: "Format hh:mm",
        phoneformat: "Telefonnummer unvollständig oder ungültig",
        timeoverlap: {
            from: "",
            to: "kein gültiger Zeitraum",
            required: "Eingabe erforderlich",
        },
    },

    booking: {
        steps: [
            {
                title: "Personalien"
            },
            {
                title: "Termin"
            },
            {
                title: "Buchen"
            },
            {
                title: "Bestätigung"
            },
        ],
        profile: {
            header: "Personalien",
            step: "Personalien",
            firstName: "Vorname",
            lastName: "Nachname",
            email: "Email",
            phone: "Telefon",
            continue: "Weiter",
            comment: "Kommentar",
        },
        appointment: {
            book: "Definitiv buchen",
            step: "Termin",
            errors: {
                noslot: "Keine freien Termine",
            },
            header: {
                offer: "Wählen Sie Ihren Termin",
                book: "Termin buchen",
                date: "Datum",
                duration: "Dauer",
                service: "Behandlung",
                time: "Zeit",
                summary: "Ihr Termin",
            },
        },
        finish: {
            step: "Fertig",
            thanks: "Danke für Ihre Buchung",
        },
        confirm: {
            confirm: "Bitte bestätigen",
            link: "Wir haben Ihnen einen Link zur Bestätigung an folgende Adresse gesendet:",
            finish: "Bitte klicken Sie in der Email auf den Link, um die Buchung zu bestätigen.",
            expired: "Ihre Anfrage ist leider abgelaufen, bitte buchen Sie neu.",
            progress1a: "Danke für Ihre Anfrage.",
            progress1b: "Der Termin wurde noch nicht gebucht.",
            progress2a: "Danke für die Bestätigung.",
            progress2b: "Ihr Termin ist reserviert.",
            thanks1: "Danke für die Bestätigung. Der Termin ist gebucht.",
            thanks2: "Sie erhalten eine Bestätigung per Email",
            step: "Bestätigung",
            toBook: "Zur Buchungsseite"
        },
    },
};



// WEBPACK FOOTER //
// ./src/i18n/i18n-de.js